<!-- Fuels Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Fuels Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-fuel-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Search</span>
        </button>

        <!-- Add Fuel Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddFuelModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Fuel
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-fuel-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span data-kt-fuel-table-select="selected_count">{{ selectedFuels.length }}</span> Selected
        </div>
        <button type="button" class="btn btn-danger" (click)="deleteSelectedFuels()" data-kt-fuel-table-select="delete_selected">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Fuels</label>
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm ps-10"
            placeholder="Search fuels..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()"
          />
        </div>
      </div>
      <div class="col-md-8 d-flex align-items-end">
        <button type="button" class="btn btn-sm btn-primary me-2" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_fuels_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-125px">Name</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let fuel of fuels; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="fuel._id"
                  [checked]="isSelected(fuel._id)"
                  (change)="toggleSelection(fuel._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ fuel.name || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(fuel)"
                  title="Edit Fuel">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteFuel(fuel)"
                  title="Delete Fuel">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
          <!-- Empty State -->
          <tr *ngIf="fuels.length === 0">
            <td colspan="3" class="text-center py-10">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No fuels found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && fuels.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Fuel Add/Edit Modal -->
<app-add-edit-fuel
  (fuelAdded)="onFuelAdded()"
  (fuelUpdated)="onFuelUpdated()">
</app-add-edit-fuel>
